import { Rule } from "antd/es/form";
import { ColProps } from "antd/es/grid/col";

type ValidationType = {
  email: {
    rules: Rule[];
    wrapperCol: ColProps;
    labelCol: ColProps;
  };
  password: {
    rules: Rule[];
    wrapperCol: ColProps;
    labelCol: ColProps;
  };
};

export const inputs: ValidationType = {
  email: {
    wrapperCol: { span: 24 },
    labelCol: { span: 24 },
    rules: [
      {
        required: true,
        message: "Fusha e e-mailit është e detyrueshme.",
      },
      {
        pattern:
          /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/,
        message: "Ky e-mail nuk është i vlefshëm!",
      },
    ],
  },
  password: {
    wrapperCol: { span: 24 },
    labelCol: { span: 24 },
    rules: [
      {
        required: true,
        message: "Ju lutemi vendosni fjalëkalimin!",
      },
    ],
  },
};
